import { render } from "./mapbox-editor.vue?vue&type=template&id=30865d35&scoped=true"
import script from "./mapbox-editor.vue?vue&type=script&lang=ts"
export * from "./mapbox-editor.vue?vue&type=script&lang=ts"

import "./mapbox-editor.vue?vue&type=style&index=0&id=30865d35&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-30865d35"

export default script